export const LoaderSizes = {
  Small: '30px',
  Base: '40px',
  Large: '50px',
};
